import React from "react";
import { IoIosArrowRoundForward, IoIosLink } from "react-icons/io";
import BulbMark from "../../component/BulbMark";
import { FormatNumber, FormatDate } from "../../helpers";
import { publicPartyGet } from "../../api";
import "./debt.css";
import "./party.css";

const PartyShare = (props) => {
  const token = props.match.params.token;
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    publicPartyGet(token)
      .then((r) => {
        if (cancelled) return;
        setData(r.data);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(
          err.response?.data?.error?.message ||
            "Link tidak valid atau sudah kedaluwarsa"
        );
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <div className="pty-share-page">
        <div className="main-padding text-center" style={{ paddingTop: "4rem" }}>
          <BulbMark size={48} />
          <p style={{ marginTop: "1rem", color: "var(--ink-muted)" }}>
            Memuat ringkasan…
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pty-share-page">
        <div className="main-padding text-center" style={{ paddingTop: "4rem" }}>
          <BulbMark size={48} />
          <h2 className="pty-name" style={{ marginTop: "1rem" }}>
            Link tidak valid
          </h2>
          <p className="pty-phone">{error}</p>
        </div>
      </div>
    );
  }

  const directionSentence =
    data.perspective === "you-owe"
      ? `Anda berutang kepada ${data.userDisplayName}`
      : data.perspective === "they-owe"
      ? `${data.userDisplayName} berutang kepada Anda`
      : "Saldo sudah lunas";
  const netClass =
    data.perspective === "they-owe"
      ? "owed"
      : data.perspective === "you-owe"
      ? "you-owe"
      : "even";

  return (
    <div className="pty-share-page">
      <header className="pty-share-page__brand">
        <BulbMark size={28} />
        <span className="pty-share-page__brand-name">cashflow</span>
      </header>

      <div className="main-padding pty-page__inner" style={{ paddingTop: 0 }}>
        <div className="pty-hero">
          <div
            className="pty-stat__label"
            style={{ marginBottom: "0.4rem", color: "var(--primary-ink)" }}
          >
            Catatan dari
          </div>
          <h1 className="pty-name">{data.userDisplayName}</h1>
          <p className="pty-phone">untuk {data.partyName}</p>

          <div className="pty-net-label">Posisi bersih</div>
          <div className={`pty-net-amount pty-net-amount--${netClass}`}>
            Rp {FormatNumber(Math.round(data.netAmount))}
          </div>
          <p className="pty-net-direction">{directionSentence}</p>

          {data.progressPct > 0 && (
            <>
              <div className="pty-progress">
                <div
                  className="pty-progress__bar"
                  style={{ width: data.progressPct + "%" }}
                />
              </div>
              <small className="pty-progress__label">
                {data.progressPct}% pelunasan keseluruhan
              </small>
            </>
          )}

          <div className="pty-stats">
            <div>
              <div className="pty-stat__label">Anda terima</div>
              <div className="pty-stat__value pty-stat__value--in">
                Rp {FormatNumber(Math.round(data.totalReceived))}
              </div>
              <div className="pty-stat__sub">total uang masuk</div>
            </div>
            <div>
              <div className="pty-stat__label">Anda bayar</div>
              <div className="pty-stat__value pty-stat__value--out">
                Rp {FormatNumber(Math.round(data.totalPaid))}
              </div>
              <div className="pty-stat__sub">total uang keluar</div>
            </div>
          </div>
        </div>

        <div className="pty-section-title">
          Riwayat · {data.timeline.length} transaksi
        </div>
        <div className="pty-timeline">
          {data.timeline.map((e, idx) => (
            <div
              className="pty-tl-event"
              key={idx}
              style={{ animationDelay: `${Math.min(idx * 0.04, 0.4)}s` }}
            >
              <span
                className={`pty-tl-event__dot pty-tl-event__dot--${
                  e.direction
                } ${e.kind === "origin" ? "pty-tl-event__dot--filled" : ""}`}
              />
              <div className="pty-tl-event__date">{FormatDate(e.at)}</div>
              <div className="pty-tl-event__row">
                <span className="pty-tl-event__label">{e.label}</span>
                <span
                  className={`pty-tl-event__amount pty-tl-event__amount--${e.direction}`}
                >
                  {e.direction === "in" ? "+" : "−"}Rp{" "}
                  {FormatNumber(Math.round(e.amount))}
                </span>
              </div>
              {e.note && <div className="pty-tl-event__note">"{e.note}"</div>}
            </div>
          ))}
        </div>

        <div className="pty-share-page__upsell">
          <div className="pty-share-page__upsell-title">
            Lacak utang Anda di sini juga
          </div>
          <p className="pty-share-page__upsell-body">
            Cashflow gratis. Daftar singkat, catat utang-piutang Anda sendiri
            dari sisi Anda.
          </p>
          <a
            href="https://cashflow.zcode.id/landing"
            className="pty-btn pty-btn--primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Daftar Sekarang <IoIosArrowRoundForward size="1.4em" />
          </a>
        </div>

        <div className="pty-share-page__footer">
          <IoIosLink /> Link berlaku sampai{" "}
          {data.expiresAt && FormatDate(data.expiresAt)} · via Cashflow
        </div>
      </div>
    </div>
  );
};

export default PartyShare;
